export const getQuestionMessageDeleteDialog = (nome, isCliente) => `Deseja excluir o ${isCliente ? 'cliente' : 'possível cliente'} ${nome}? Ao confirmar,
 o ${isCliente ? 'cliente' : 'possível cliente'} será excluído permanentemente`;
export const CIDADE = 'Cidade';
export const ESTADOS = 'Estado';
export const CPF_CNPJ = 'CPF/CNPJ';
export const UNIDADE_RESPONSAVEL = 'Unidade Responsável';
export const COD_CLIENTE = 'Código';
